<template>
    <div>
        <!--预定结算-->
        <el-dialog :visible.sync="visible"
                   class="ele-toast" :close-on-click-modal="false" :before-close="resetForm" width="960px">
            <div slot="title">
                <z-title title="婚庆提成"></z-title>
            </div>
            <div class="plr-20 lh-30">
                <weddingbase :info="info" showcustom-from></weddingbase>
                <el-table
                        cell-class-name="cellclass"
                        :data="dataList"
                        :summary-method="getSummaries"
                        show-summary
                        style="width:100%">
                    <el-table-column
                            fixed
                            align="center"
                            label="序 号"
                            min-width="90">
                        <template slot-scope="scope">
                            {{scope.$index+1}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="createTime"
                            label="审核日期"
                            min-width="180"
                            align="center">
                    </el-table-column>
                    <el-table-column
                            label="金额类型"
                            min-width="80"
                            align="center">
                        <template slot-scope="scope">
                            <div class="ptb-10">
                                <el-tag v-if="scope.row.confirmType==0" size="mini" type="success">入账</el-tag>
                                <el-tag v-else-if="scope.row.confirmType==1" size="mini" type="danger">退款</el-tag>
                                <el-tag v-else size="mini" type="warning">补账</el-tag>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="remark"
                            label="审核事项"
                            min-width="180"
                            align="center">
                    </el-table-column>
                    <el-table-column
                            prop="confirmName"
                            label="审核人员"
                            min-width="150"
                            align="center">
                    </el-table-column>
                    <el-table-column
                            label="确认收款金额"
                            width="160"
                            align="center">
                        <template slot-scope="scope">
                            {{scope.row.confirmType==1?'-':''}}{{scope.row.confirmMoney}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="收款时间"
                            width="160"
                            align="center">
                        <template slot-scope="scope">
                            {{scope.row.confirmType==1?'-':''}}{{scope.row.confirmMoney}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="入账账户"
                            width="100"
                            align="center">
                        <template slot-scope="scope">
                            {{scope.row.confirmType==1?'-':''}}{{scope.row.confirmMoney}}
                        </template>
                    </el-table-column>
                </el-table>
                <el-divider class="title" content-position="left">提成结算</el-divider>
                <el-form :model="dataForm" :rules="rules" ref="dataForm" label-width="90px" class=" mt-10">
                    <div class="flex-n">
                        <el-form-item label="提成方式"  prop="commission">
                            <div class="flex-n fac">
                                <el-select :disabled="state==1" v-model="dataForm.commission" placeholder="请选择提成规则" value-key="id" @change="changeCommission">
                                    <el-option
                                            v-for="item,index in commissionList"
                                            :key="item.id"
                                            :label="item.commissionTitle"
                                            :value="item">
                                    </el-option>
                                </el-select>
                                <div class="ml-10" v-if="dataForm.commissionType=='1'||dataForm.commissionType=='2'">
                                    {{dataForm.commissionMoney?('提成金额: '+dataForm.commissionMoney):('提成金额: '+0)}}
                                </div>
                            </div>
                        </el-form-item>
                        <!--自定义提成-->
                        <el-form-item label="提成金额" prop="commissionMoney" v-if="dataForm.commissionType=='3'">
                            <div class="flex-n fac">
                                <el-input-number :disabled="state==1" class="mr-10" placeholder="￥" v-model="dataForm.commissionMoney"
                                                 :controls="false"
                                                 :min="0" :precision="2" :step="0.1" :max="9999999999"></el-input-number>
                                <div>元</div>
                            </div>
                        </el-form-item>
                    </div>

                    <el-form-item class="mt-10 flex-n fje" v-if="state==0">
                        <el-button type="primary" @click="submit('dataForm')">保 存</el-button>
                        <el-button @click="resetForm">取 消</el-button>
                    </el-form-item>

                </el-form>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import ZTitle from "../../../components/ZTitle";
    import Weddingbase from "../../component/weddingbase";
    import Payment from "../../../components/data/payment";

    export default {
        components: {
            Payment,
            Weddingbase,
            ZTitle,
            },
        name: "wed-commission",
        props:{
            visible: Boolean,
            id: String,
            wedId:String,
            state:String|Number
        },
        data() {

            return {
                loading:false,
                dataList:[],

                info:{},
                dataForm: {
                    commission:null,
                    commissionMoney:''
                },
                rules: {
                    commission:[{required: true, message: ' ', trigger: 'change'}],
                    commissionMoney:[{required: true, message: ' ', trigger: 'change'}]
                },
                commissionList:[],

                orderRealMoney:0,
            }
        },
        watch:{
            visible(newval,oldval){
                if(newval){
                    this.getInfo();
                    this.getData();
                    this.getCommissionList();
                }
            },
        },

        methods:{
            //获取提成下拉列表
            getCommissionList(){
                this.$axios.post('/orderCommissionConfig/commissionList',{
                    storeId:this.$root.getStorage('storeId'),
                    orderCategory:'1'
                }).then(res=>{
                    console.log(res.data)
                    this.commissionList=res.data.list;
                }).catch(err=>{
                    this.$message.error(err.msg)
                })
            },
            //获取收款记录信息
            getData(){
                this.$axios.get('/orderFinanceConfirm/financeConfirmDetail/' + this.id).then(res => {
                    console.log(res)
                    this.dataList = res.data.list;
                }).catch(err => {
                    this.$message.error(err.msg);
                })
            },

            getInfo(){
                //上半部基本信息
                this.$axios.get('/wedding/orderWeddingDetail/' + this.wedId).then(res => {
                    console.log(res)
                    var info = res.data;
                    this.info = info;
                    if(info.userCommission.length>0){
                        this.$set(this.dataForm,'commission',{
                            id:info.userCommission[0].commissionConfigId,
                            "commissionTitle": info.userCommission[0].commissionTitle,
                            "commissionValue": info.userCommission[0].commissionValue,
                            "commissionValueType":info.userCommission[0].commissionValueType
                        })
                        this.$set(this.dataForm,'commissionMoney',info.userCommission[0].commissionMoney);
                        this.changeCommission(this.dataForm.commission);
                    }
                    console.log(this.dataForm)

                }).catch(err => {
                    this.$message.error(err.msg);
                })
            },
            changeCommission(data){
                var payTypes=[];
                payTypes=this.info.payTypes;
                this.$set(this.dataForm,'commissionType',data.commissionValueType);//提成类型设置
                console.log(data,this.orderRealMoney,payTypes)
                if(data.commissionValueType=='1'||data.commissionValueType=='2'){
                    this.$axios.post('/userCommission/calcOrderCommission',{
                        "orderCommissionConfigId": data.id,
                        "orderRealMoney": this.orderRealMoney,
                        "orderPayments": payTypes
                    }).then(res=>{
                        console.log('计算金额',res.data);
                        this.$set(this.dataForm,'commissionMoney',res.data.commissionMoney);
                    }).catch(err=>{
                        this.$message.error(err.msg);
                    })
                }
                // else{
                //     this.$set(this.dataForm,'commissionMoney',0);
                // }

            },
            submit(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        var dataForm=this.dataForm;
                        this.$axios.post('/userCommission/save', {
                            "commissionConfigId": dataForm.commission.id,
                            "commissionMoney": dataForm.commissionMoney,
                            "commissionTitle": dataForm.commission.commissionTitle,
                            "commissionValue": dataForm.commission.commissionValue,
                            "orderId": this.id,
                            // "remark": dataForm.commission.remark,
                            "userId": this.$root.getStorage('info').userId,

                        }).then(res => {
                            this.$message.success('提成结算成功！');
                            this.resetForm();
                        }).catch(err => {
                            this.$message.error(err.msg);
                        })
                    } else {
                        this.$message.error('表单填写有误');
                        return false;
                    }
                });

            },
            getSummaries(param) {
                const {columns, data} = param;
                const sums = ['累计收款', '', '', '', ''];
                var sum = 0;
                for (var i = 0, len = data.length; i < len; i++) {
                    sum += Number((data[i].confirmType == 1 ? '-' : '') + Number(data[i].confirmMoney));
                }
                sums[5] = sum;
                this.orderRealMoney=sum;
                return sums;
            },
            resetForm(){
                this.$refs.dataForm.resetFields();
                this.$emit('refreshList');
                this.$emit('update:visible', false);
            }

        },
    }
</script>

<style scoped lang="scss">
    .el-divider__text {
        font-weight: 700 !important;
        color: #5295e7;
    }

</style>